/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-05-15 14:37:23
 * @LastEditors: changfeng
 * @LastEditTime: 2024-09-09 19:58:04
 */
export default {
	"subscription.intro.title": "请选择您的套餐",
	"subscription.intro.subtitle": "发现适合您独特广告需求的完美套餐",
	"subscription.intro.subtitle1": "收取每月订阅费用后，您将获得7天免费试用。您可以在 7 天试用期内随时取消订阅并申请退款。",
	"subscription.intro.button.currentPlan": "当前套餐",

	"subscription.intro.standard.title": "标准版",
	"subscription.intro.standard.timeUnits": "月",
	"subscription.intro.standard.item1": "无限量授权广告账户",
	"subscription.intro.standard.item2": "连接的广告账户数量上限30个",
	"subscription.intro.standard.item3": "创建规则数量上限20条，规则生效的广告账户数量上限10个",
	"subscription.intro.standard.item4": "一键创建和管理广告",
	"subscription.intro.standard.item5": "团队成员人数上限5个",
	"subscription.intro.standard.item6": "清晰直观的仪表盘数据",
	"subscription.intro.standard.item7": "规则每10分钟运行一次",
	"subscription.intro.standard.item8": "工作日通过邮件提供技术支持",
	"subscription.intro.standard.button": "选择标准版",

	"subscription.intro.professional.title": "专业版",
	"subscription.intro.professional.timeUnits": "月",
	"subscription.intro.professional.item1": "无限量授权广告账户",
	"subscription.intro.professional.item2": "连接的广告账户数量上限50个",
	"subscription.intro.professional.item3": "创建规则数量上限50条，规则生效的广告账户数量上限20个",
	"subscription.intro.professional.item4": "一键创建和管理广告",
	"subscription.intro.professional.item5": "团队成员人数上限20个",
	"subscription.intro.professional.item6": "清晰直观的仪表盘数据",
	"subscription.intro.professional.item7": "规则每5分钟运行一次",
	"subscription.intro.professional.item8": "工作日通过微信提供技术支持",
	"subscription.intro.professional.button": "选择专业版",
	"subscription.intro.professional.mostPopular": "最受欢迎",

	"subscription.intro.business.title": "企业版",
	"subscription.intro.business.timeUnits": "月",
	"subscription.intro.business.item1": "无限量授权广告账户",
	"subscription.intro.business.item2": "无限量连接广告账户",
	"subscription.intro.business.item3": "无限量创建规则，无限量生效的账户",
	"subscription.intro.business.item4": "一键创建和管理广告",
	"subscription.intro.business.item5": "团队成员人数无限制",
	"subscription.intro.business.item6": "清晰直观的仪表盘数据",
	"subscription.intro.business.item7": "规则每1分钟运行一次",
	"subscription.intro.business.item8": "全天候提供技术支持",
	"subscription.intro.business.button": "联系我们",

	"subscription.intro.footer.text": "收取每月订阅费用后，您将获得7天免费试用。您可以在 7 天试用期内随时取消订阅并申请退款。",

	"subscription.upgrade.modal.title": "升级套餐",
	"subscription.upgrade.modal.text": "您确定要升级到专业版套餐吗？",
	"subscription.upgrade.modal.ok": "升级套餐",

	"subscription.referrals.title": "邀请有礼 ",
	"subscription.referrals.left.title": "每邀请1位新好友领$5奖励 ",
	"subscription.referrals.left.intro":
		"好友通过邀请链接注册成功即可获得$5代金券用于套餐订阅，当其套餐订阅成功时邀请者可得$5代金券",
	"subscription.referrals.left.button": "复制邀请链接",
	"subscription.referrals.left.button.success": "邀请链接已复制到剪切板",

	"subscription.referrals.right.title": "邀请收益",
	"subscription.referrals.right.intro": "总收益",
	"subscription.paurches.modal.sub": "首次购买将额外赠送您七天的权益，如不满意，您可在七天内无条件全额退款",
	"subscription.skip to billing": "跳转至账单"
};
